import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  SearchByBoiSerial,
  SearchByBoiSerialVariables
} from '../../board/hooks/__generated__/SearchByBoiSerial'

const MUTATION = gql`
  mutation SearchByBoiSerial($input: SearchByBoiSerialInput!) {
    searchByBoiSerial(input: $input) {
      device {
        id
        created
        pairingCode
        firmwareVersion
        latestHeartbeat {
          id
          created
        }
        configurationNetwork {
          id
          ssid
        }
      }
      hardware {
        id
        boiSerialNumber
        created
      }
    }
  }
`

export const useSearchByBoiSerial = () => {
  return useMutation<SearchByBoiSerial, SearchByBoiSerialVariables>(MUTATION)
}
